const mapXHREvent = (request: ProgressEvent<XMLHttpRequest>) => {
  return {
    status: request.target?.status || 0,
    body: request.target?.response,
  };
};

export const networkInterceptorLib = {
  mapXHREvent,
};
